import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	standalone: true,
	selector: "obg-app-my-offers-offer-details",
	templateUrl: "./my-offers-offer-details.component.html",
	styleUrls: ["./my-offers-offer-details.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		"[class.obg-app-my-offers-offer-details]": "true",
	},
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [CommonModule, RouterModule],
})
export class MyOffersOfferDetailsComponent {
	protected readonly offerId$: Observable<string | null>;

	constructor(private readonly activatedRoute: ActivatedRoute) {
		this.offerId$ = this.activatedRoute.paramMap.pipe(map((params) => params.get("offerId")));
	}
}
